<template>
  <div>
    <div align="left">
      <br />
      <h5 class="font-weight-bold text-primary">Captcha Image</h5>
      <br />
    </div>
    <b-card class="text-left">
      <b>Create New Captcha Image</b>
      <b-row class="mt-4">
        <b-col md="6">
          <b-form-group
            id="input-group-1"
            label-class="control-label mb-n1"
            class="required"
            label="Image"
            label-for="input-1"
          ></b-form-group>
          <b-card body-class="py-2 px-2">
            <card-body>
              <b-row>
                <b-col class="text-primary mt-2">
                  <i class="fas fa-paperclip"></i>&nbsp;
                  <b>{{image.name || 'Name'}}</b>
                  <sup class="text-secondary pl-3">(2 Mb)&nbsp;(280px x 155px)</sup>
                </b-col>
                <b-col md="4" class="text-right" align="right">
                  <input
                    type="file"
                    ref="image"
                    name="image"
                    v-validate="'required|image|minimalDimensions:280,155|size:2000|ext:jpg,png,gif,jpeg'"
                    style="display: none"
                    v-on:change="onChangeimage()"
                  />
                  <b-button
                    @click="$refs.image.click()"
                    v-show="!image"
                    variant="primary"
                    class="ml-5"
                  >Select File</b-button>
                  <b-button
                    v-show="image"
                    variant="primary"
                    @click="modalImage = !modalImage"
                    class="mr-2"
                  >Preview</b-button>
                  <b-button
                    @click="$refs.image.click()"
                    v-show="image"
                    variant="outline-primary"
                    class
                  >Change File</b-button>
                </b-col>
              </b-row>
            </card-body>
          </b-card>
          <p
            class="text-danger"
            style="width:100%;margin-top:.25rem;font-size: 80%;"
          >{{ veeErrors.first('image') }}</p>
        </b-col>
      </b-row>
      <br />
      <b-row class="text-right">
        <b-col md="2" class="text-left">
          <label class="text-danger">
            <b class="text-dark">Required</b>
          </label>
        </b-col>
        <b-col>
          <b-button variant="primary" :disabled="loading" @click="post()" class="mr-3" size="lg">
            Create
            <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          </b-button>
          <router-link :to="{name: 'Captcha'}">
            <b-button variant="outline-secondary" size="lg">Cancel</b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="modalImage" title="Preview Image" size="xl">
      <img v-if="urlImage" width height="400px" :src="urlImage" />
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      section: "",
      widthImage: null,
      heightImage: null,
      urlImage: "",
      image: "",
      modalImage: false
    };
  },
  methods: {
    post() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;
          const formData = new FormData();
          formData.append("image_url", this.image);
          this.$store
            .dispatch("CaptchaModule/postCaptcha", formData)
            .then(response => {
              this.loading = false;
              this.$router.push({ name: "Captcha" });
              this.$swal({
                type: "success",
                title: "Your work has been saved",
                showConfirmButton: false,
                timer: 1500
              });
              console.log(response);
            })
            .catch(error => {
              this.loading = false;
              this.$swal({
                type: "error",
                title: "Oops...",
                text: error.response.data,
                showConfirmButton: false,
                timer: 1500
              });
              this.serverError = error.response.data;
              console.log(error);
            });
        } else {
          this.$swal({
            type: "error",
            title: "Oops...",
            text: this.$validator.errors.all(),
            showConfirmButton: false,
            timer: 1500
          });
        }
      });
    },
    onChangeimage() {
      this.image = this.$refs.image.files[0];
      const input = this.$refs.image;
      const { files } = input;
      if (files && files[0]) {
        const reader = new FileReader();
        reader.onload = e => {
          const img = new Image();
          img.onload = () => {
            this.widthImage = img.width;
            this.heightImage = img.height;
          };
          img.src = e.target.result;
          this.urlImage = e.target.result;
        };
        reader.readAsDataURL(files[0]);
        this.$emit("input", files[0]);
      }
    }
  }
};
</script>

<style>
</style>
